/* eslint-disable space-before-function-paren */
<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="故障详情"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="tj historyDiares faultDiares" :style="{ height: pageHeight-70 + 'px' }">
      <!-- <van-image
  width="100%"
  height="100%"
  src="https://img01.yzcdn.cn/vant/cat.jpeg"
/> -->
<!-- 22vh fill -->
    <div :style="{'height':mapDisplay ? '22vh':'50vh'}" style="margin-bottom: 12px;box-shadow: 0px 2px 6px rgb(0 0 0 / 10%);">
      <van-image width="100%" height="100%" fit="contain" :src="xlsrcImg" >
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
    </div>

      <ul>
        <li class="item">
          <!-- <h3>xxx线路名称名称2-速断故障</h3>
          <van-steps direction="vertical" :active="2" active-color="#C9C9C9">
            <van-step>
              <van-button color="#F27A2B" plain size="mini">区间定位</van-button>
              <p>
                2021/1/22 08:00:25xxxxx线路名称发生速断故障，故障区段在南湖支线#2与南湖支线#14之间。
              </p>
            </van-step>
            <van-step>
              <van-button color="#0BA57B" plain size="mini">精确定位</van-button>
              <p>
                2021/1/22 08:00:25xxxxx线路名称发生速断故障，故障区段在南湖支线#2。
              </p>
            </van-step>
          </van-steps> -->
          <h3>{{diaresVO.mlName}}-{{diaresVO.diaTypeName}}</h3>
          <p>{{diaresVO.diaRemark}}</p>
          <!-- <van-button :color="diaresVO.fixedType == 0 ? '#F27A2B' :(diaresVO.fixedType==1?'#0BA57B':'')" plain size="mini">{{diaresVO.fixedType == 0 ? '区间' : (diaresVO.fixedType==1?'精确':'')}}定位</van-button> -->
        </li>
      </ul>
      <!-- <ul v-show="mapDisplay">
        <li class="item" >
          <h3>设备状态</h3>
          <div style="height:30vh;margin-top:10px;position: relative;">
            <div style="height:100%;width:100%;" class="baiduMap" id="allmap" ref="allmap"></div>

          </div>
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Col,
  Row,
  Button,
  NavBar,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Grid,
  GridItem,
  Image as VanImage,
  Step, Steps, Loading
} from 'vant'

// 以import的方式导入图片文件
// import iconDlx3 from '../assets/dlx@31.png.png'// 电缆型设备
// import iconDlx2 from '../assets/dlx@22.png.png'
// import iconJks2 from '../assets/jkx@22.png.png'// 架空型设备
// import iconJks3 from '../assets/jkx@31.png.png'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(
  Col,
  Row,
  Button,
  NavBar,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Grid,
  GridItem,
  VanImage, Step, Steps, Loading

)

export default {
  name: 'faultDiaresPage',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [VanImage.name]: VanImage,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Loading.name]: Loading
  },
  data () {
    return {
      xlsrcImg: '',
      mlineId: '',
      zoom: 13, // 缩放级别
      points: [], // 地图所有坐标点对象
      pageHeight: window.innerHeight,
      diaresVO: {},
      mapDisplay: null, // 是否显示地图true显示，false隐藏
      list: [],
      listType: []// 设备状态 1架空型 2电缆型 3开关型
    }
  },
  mounted () {
    // console.log(this.$route.query.nmlineId)
    this.mlineId = this.$route.query.mlineId
    this.getDiaresDetail()// 故障详情接口
  },
  created () {
    this.xlsrcImg = `${this.setUserImages()}&v=${Math.random() * 10}`
  },
  methods: {
    getDiaresDetail () {
      this.util.post('/getDiaresDetail', {
        acciId: this.$route.query.acciId // 故障id
      }).then(({ data }) => {
        if (data.code === 200) {
          this.mapDisplay = data.data.mapDisplay
          if (window.config.type === 1) {
            this.mapDisplay = false
          }
          this.diaresVO = data.data.diaresVO
          this.list = data.data.list// 地图上需要展示的信息
          this.listType = data.data.listType// 设备状态 1架空型 2电缆型 3开关型
          // this.initMap()
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    todeviceStatus () {
      // alert(1)
      this.$router.push({
        path: '/deviceStatusPage', query: { acciId: this.$route.query.acciId } // 跳转到设备状态页
      })
    },
    initMap () {
      this.createMap() // 创建地图
      this.setMapEvent()// 设置地图事件
      this.addMapControl()// 向地图添加控件
      this.addMarker()// 向地图中添加marker
      setTimeout(() => {
        this.setViewport()// 设置地图视野层级
      }, 500)
    },
    createMap () {
      // eslint-disable-next-line no-undef
      var map = new window.BMap.Map(this.$refs.allmap)// 在百度地图容器中创建一个地图
      // eslint-disable-next-line no-undef
      var point = new window.BMap.Point(106.097968, 38.063272)// 定义一个中心点坐标
      map.centerAndZoom(point, 13)// 设定地图的中心点和坐标并将地图显示在地图容器中
      window.map = map// 将map变量存储在全局
      map.addEventListener('click', this.todeviceStatus)
    },
    setMapEvent () {
      // eslint-disable-next-line no-undef
      // map.enableDragging()// 启用地图拖拽事件，默认启用(可不写)
      // eslint-disable-next-line no-undef
      map.disableDragging()// 禁止拖曳，否则不能点击
      // eslint-disable-next-line no-undef
      map.enableScrollWheelZoom()// 启用地图滚轮放大缩小
      // eslint-disable-next-line no-undef
      map.enableDoubleClickZoom()// 启用鼠标双击放大，默认启用(可不写)
      // eslint-disable-next-line no-undef
      map.enableKeyboard()// 启用键盘上下左右键移动地图
    },
    addMapControl () {
      // 向地图中添加缩放控件
      // var ctrl_nav = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_TOP_LEFT, type: BMAP_NAVIGATION_CONTROL_LARGE })
      // map.addControl(ctrl_nav)
    },
    // animateGt (obj) {
    //   console.log(obj)
    //   console.log(obj.Zc)
    //   // console.log(obj.$c+"---"+obj.Yc)
    //   // alert(1)
    //   var divElement = document.createElement('div')
    //   // divElement.className = 'before';
    //   var divElement2 = document.createElement('div')
    //   divElement2.className = 'after'
    //   obj.Zc.innerHtml = obj.Zc.childNodes[0]
    //   obj.Zc.appendChild(divElement)
    //   obj.Zc.appendChild(divElement2)
    //   obj.Zc.className = ''
    //   obj.Zc.className = 'dot gt'
    //   obj.Zc.style.overflow = ''
    //   obj.Zc.firstChild.style.position = 'relative'
    //   obj.Zc.firstChild.style.zIndex = '5'
    // },
    addMarker () {
      let markerArr = this.list
      // console.log(this.list)

      // var point = []// 定义数组标注经纬信息
      var marker = []// 定义数组点对象信息
      // var info = []// 定义悬浮提示信息
      var pointArr = []

      for (var i = 0; i < markerArr.length; i++) { // 遍历
        // var infoA = markerArr[i].point.split('|')[0]// 分割|
        // var infoB = markerArr[i].point.split('|')[1]
        var infoA = markerArr[i].longitude
        var infoB = markerArr[i].latitude
        let point = new window.BMap.Point(infoA, infoB)

        pointArr.push(point)

        point[i] = new window.BMap.Point(infoA, infoB)

        marker[i] = new window.BMap.Marker(point[i])

        // 自定义图标
        let iconSize2 = new window.BMap.Size(22, 22)
        let iconSize3 = new window.BMap.Size(31, 52)
        let dlxIcon2 = new window.BMap.Icon(require('../assets/map/dlx.svg'), iconSize2)// 电缆
        let dlxIcon3 = new window.BMap.Icon(require('../assets/map/dlx-on.svg'), iconSize3)
        let jksIcon2 = new window.BMap.Icon(require('../assets/map/jkx.svg'), iconSize2)// 架空
        let jksIcon3 = new window.BMap.Icon(require('../assets/map/jkx-on.svg'), iconSize3)
        // 开关型
        let kghIcon2 = new window.BMap.Icon(require('../assets/map/dlqh.svg'), iconSize2)// 合
        let kghIcon3 = new window.BMap.Icon(require('../assets/map/dlqh-on.svg'), iconSize3)
        let kgfIcon2 = new window.BMap.Icon(require('../assets/map/dlqf.svg'), iconSize2)// 分
        let kgfIcon3 = new window.BMap.Icon(require('../assets/map/dlqf-on.svg'), iconSize3)
        let kgycIcon2 = new window.BMap.Icon(require('../assets/map/txdk.svg'), iconSize2)// 异常
        let kgycIcon3 = new window.BMap.Icon(require('../assets/map/txdk-on.svg'), iconSize3)
        // 判断
        // console.log(this.list)
        if (markerArr[i].dtuStatus === 1) {
          // 架空型设备
          let marker = new window.BMap.Marker(point[i], {
            icon: jksIcon2
          })
          // console.log(point)
          window.map.addOverlay(marker)
          // console.log(markerArr[i])
          var label = new window.BMap.Label(markerArr[i].mlName + markerArr[i].elepoId, { offset: new window.BMap.Size(-25, -20) })
          label.setStyle({
            color: '#353535',
            fontSize: '12px',
            backgroundColor: '0.01',
            border: '0',
            textShadow: '#ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0, #ffffff 0 -1px 0'
          })
          marker.setLabel(label)
          marker.addEventListener('click', function () {
            marker.setIcon(jksIcon3)// 设置图标
            // let allOverlay = map.getOverlays()
            // console.log(allOverlay)
            // for (let i = 0; i < allOverlay.length; i++) {
            //   if (allOverlay[i].getLabel().content === label) { // 获取到你想要改变的marker
            //     // allOverlay[i].setIcon(perIcon2)// 变成另一个icon
            //     alert(2)
            //   }
            // }
          })
        } else if (markerArr[i].dtuStatus === 2) {
          // 电缆型设备
          let marker = new window.BMap.Marker(point[i], {
            icon: dlxIcon2
          })
          window.map.addOverlay(marker)
          // eslint-disable-next-line no-redeclare
          var label = new window.BMap.Label(markerArr[i].mlName + markerArr[i].elepoId, { offset: new window.BMap.Size(-25, -20) })
          label.setStyle({
            color: '#353535',
            fontSize: '12px',
            backgroundColor: '0.01',
            border: '0',
            textShadow: '#ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0, #ffffff 0 -1px 0'
          })
          marker.setLabel(label)
          marker.addEventListener('click', function () {
            marker.setIcon(dlxIcon3)// 设置图标
          })
        } else if (markerArr[i].dtuStatus === 3) {
          // 开关型设备
          // kgStatus 开关状态 1合 2分 3异常
          if (markerArr[i].kgStatus === 1) {
            // 合
            let marker = new window.BMap.Marker(point[i], {
              icon: kghIcon2
            })
            window.map.addOverlay(marker)
            // eslint-disable-next-line no-redeclare
            var label = new window.BMap.Label(markerArr[i].mlName + markerArr[i].elepoId, { offset: new window.BMap.Size(-25, -20) })
            label.setStyle({
              color: '#353535',
              fontSize: '12px',
              backgroundColor: '0.01',
              border: '0',
              textShadow: '#ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0, #ffffff 0 -1px 0'
            })
            marker.setLabel(label)
            marker.addEventListener('click', function () {
              marker.setIcon(kghIcon3)// 设置图标
            })
          } else if (markerArr[i].kgStatus === 2) {
            // 分
            let marker = new window.BMap.Marker(point[i], {
              icon: kgfIcon2
            })
            window.map.addOverlay(marker)
            // eslint-disable-next-line no-redeclare
            var label = new window.BMap.Label(markerArr[i].mlName + markerArr[i].elepoId, { offset: new window.BMap.Size(-25, -20) })
            label.setStyle({
              color: '#353535',
              fontSize: '12px',
              backgroundColor: '0.01',
              border: '0',
              textShadow: '#ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0, #ffffff 0 -1px 0'
            })
            marker.setLabel(label)
            marker.addEventListener('click', function () {
              marker.setIcon(kgfIcon3)// 设置图标
            })
          } else if (markerArr[i].kgStatus === 3) {
            // 异常
            let marker = new window.BMap.Marker(point[i], {
              icon: kgycIcon2
            })
            window.map.addOverlay(marker)
            // eslint-disable-next-line no-redeclare
            var label = new window.BMap.Label(markerArr[i].mlName + markerArr[i].elepoId, { offset: new window.BMap.Size(-25, -20) })
            label.setStyle({
              color: '#353535',
              fontSize: '12px',
              backgroundColor: '0.01',
              border: '0',
              textShadow: '#ffffff 1px 0 0, #ffffff 0 1px 0, #ffffff -1px 0 0, #ffffff 0 -1px 0'
            })
            marker.setLabel(label)
            marker.addEventListener('click', function () {
              marker.setIcon(kgycIcon3)// 设置图标
            })
          }
        }
      }
      this.points = pointArr
    },
    setViewport () {
      if (this.list.length === 0) {
        var geolocation = new window.BMap.Geolocation()
        geolocation.getCurrentPosition(function getinfo (position) {
          let city = position.address.city // 获取城市信息
          window.map.centerAndZoom(city, 10)// 默认定位到用户所在城市
        }, function (e) {
          // alert('获取百度定位位置信息失败')
        }, { provider: 'baidu' })
      } else {
        // console.log(this.points)
        // setTimeout(() => {
        window.map.setViewport(this.points)// 根据提供的地理区域或坐标设置地图视野，调整后的视野会保证包含提供的地理区域或坐标
        // }, 500);
        // window.map.setZoom(window.map.getZoom() - 1)
      }
    },
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1)// 返回上一页面
    },
    setUserImages () {
      // console.log(this.$route.query.nmlineId)
      // https://pwapp.whxzg181.cn/api/showMlineImg?mlineId=
      return window.config.baseUrl + '/showMlineImg?mlineId=' + this.$route.query.mlineId// 展示线路图
    }
  }
  // computed: {
  //   xlsrcImg () {
  //     console.log(this.$route.query.mlineId)
  //     let xlsrcImg = 'https://pwapp.whxzg181.cn/api/showMlineImg?mlineId=' + this.$route.query.mlineId// 展示线路图
  //     return xlsrcImg
  //   }

  // }
}
</script>

<style scoped lang="less">
/deep/.van-dropdown-menu__bar {
  height: 34px;
}
/deep/.van-nav-bar__content {
  height: 90px;
  background: url("../assets/gzxqbj@3x.png") no-repeat top center;
  background-size: 100% 100%;
  // background-color:linear-gradient(227deg, #06C8B5 0%, #007CF8 100%);
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
/deep/.van-step__circle {
    width: 9px;
    height: 9px;
}
/deep/.van-steps--vertical {
    padding: 0 0 0 20px;
}
.xlbox{
  padding-top: 70px;
  overflow: hidden;
}
.home{
  // width:calc(100% - 24px);
  width: 100vw;
}
.home .tj {
  padding: 0 12px;
}
.historyDiares li p {
    padding: 10px 0 0;
}
.van-image__img, .van-image__error, .van-image__loading{
  border-radius: 4px;
}

.van-button {
  vertical-align: middle;
}
/deep/.van-image img{
  background: #075f85;
}
</style>
